export const legendArticle = {
    id: 'legend-categories',
    title: 'Легенда',
    category: 'Режим Данные',
    requiredModule: null,
    gif: null,
    summary: 'Единый классификатор категорий, палитра цветов, штриховки участков, типы линий дорог, кастомные иконки меток и фильтрация объектов на карте.',
    markdown: `
> **Легенда и классификатор** — это главный каталог правил и стилей вашей карты. Здесь настраивается, какими цветами и узорами заливать участки, как обозначать дороги и коммуникации, а также какие значки ставить над объектами инфраструктуры.

---

## 1. Главные плюсы и возможности

:::grid cols=2
:::card icon="sparkles" title="Единый источник стилей"
Вам **не нужно перекрашивать объекты вручную**: если в легенде изменить цвет или штриховку категории, абсолютно все привязанные к ней участки, дома или линии на карте **моментально обновятся сами**.
:::

:::card icon="sliders" title="Гибкая визуальная настройка"
Каждому типу объектов доступны свои выразительные стили:
* **Участки и здания:** выбор цвета из палитры + 6 видов геометрических штриховок.
* **Линии и дороги:** сплошные, пунктирные и точечные начертания.
* **Метки:** загрузка любых собственных графических иконок (SVG, PNG, JPG).
:::
:::

---

## 2. Четыре типа объектов в классификаторе

В окне менеджера легенды предусмотрено 4 вкладки — по одной для каждого типа геометрии на карте:

![Управление категориями и автоматическое обновление стилей](/gifs/tools/legend.gif)

:::grid cols=2
:::card icon="square" title="1. Участки (Земля и зоны)"
* **Цвет:** выбор любого оттенка для категорий (ИЖС, коммерция, рекреация, паркинг).
* **Штриховка (6 видов):** *Сплошная (нет), горизонтальная, вертикальная, диагональная, сетка (крест), диагональный крест*. Удобно для выделения водоохранных зон, сервитутов или участков с ограничениями.
:::

:::card icon="box" title="2. Здания (2D и 3D дома)"
* **Цвет стен и крыш:** индивидуальный цвет для типов строений (коттеджи, таунхаусы, инфраструктура). В 3D-режиме цвет автоматически передается на объёмные модели с учётом этажности.
* **Штриховка:** наглядное обозначение строящихся или проектируемых корпусов.
:::

:::card icon="road" title="3. Линии (Дороги и сети)"
* **Цвет линии:** асфальт (серый), водопровод (синий), газ (жёлтый), электричество (красный).
* **Тип начертания:**
  * **Сплошная** — основные дороги и действующие сети;
  * **Пунктирная** — проектируемые проезды и строящиеся сети;
  * **Точечная** — кабели, заборы и межевые границы.
:::

:::card icon="pin" title="4. Метки (Значки инфраструктуры)"
* **Свои иконки:** загружайте с компьютера логотипы и пиктограммы (КПП, пляж, спортплощадка, магазин).
* **Превью:** значок сразу виден в строке категории.
:::
:::

---

## 3. Отображение на публичной карте и фильтрация

Именно **эта настроенная вами легенда отображается пользователям на публичной карте**.

Для покупателей и посетителей сайта легенда работает как **интерактивный фильтр**:
* С помощью чекбоксов напротив категорий пользователи могут **включать и выключать видимость** нужных групп объектов (например, скрыть все дороги или оставить на карте только участки ИЖС).
* Кнопки **«Все»** и **«Сброс»** позволяют в один клик показать все слои или очистить карту.

---

## 4. Что происходит при удалении категории?

Если вы удаляете категорию в менеджере легенды:

:::warning Особенности удаления категорий
* **Удаление из списков и фильтров:** категория сразу исчезает из классификатора и больше не отображается в фильтре легенды на карте.
* **Объекты, которым была назначена эта категория:** сами контуры участков, домов или дорог с карты не удаляются, но теряют привязку к удалённой категории (перестают по ней группироваться и фильтроваться). При последующем редактировании такого объекта в его паспорте достаточно выбрать новую действующую категорию.
* **Файлы меток:** если удаляется категория метки, прикреплённый файл иконки автоматически удаляется с сервера.
:::
`
};

